module.exports = __webpack_public_path__ + "img/tomasz.24155fea.png";